import mbs5 from "../images/mbs_5.jpg";
import mbs4 from "../images/mbs_4.jpg";
import mbs3 from "../images/mbs_3.jpg";
import mbs2 from "../images/mbs_2.jpg";
import mbs1 from "../images/mbs_1.jpg";
import christmas1 from "../images/Christmas_1.jpg";
import christmas2 from "../images/Christmas_2.jpg";
import christmas3 from "../images/Christmas_3.jpg";
import christmas4 from "../images/Christmas_4.jpg";
import yk1 from "../images/yk_1.jpg";
import yk2 from "../images/yk_2.jpg";
import funan1 from "../images/funan_1.jpg";
import funan2 from "../images/funan_2.jpg";
import funan3 from "../images/funan_3.jpg";
import funan4 from "../images/funan_4.jpg";
import raffles1 from "../images/raffles_1.jpg";
import drive1 from "../images/drive_1.jpg";
import drive2 from "../images/drive_2.jpg";
import cny1 from "../images/cny_1.jpg";
import cny2 from "../images/cny_2.jpg";
import cny3 from "../images/cny_3.jpg";
import cny4 from "../images/cny_4.jpg";
import sunset1 from "../images/sunset_1.jpg";
import dragon1 from "../images/dragon_1.jpg";
import dragon2 from "../images/dragon_2.jpg";
import dragon3 from "../images/dragon_3.jpg";
import chinatown1 from "../images/chinatown_1.jpg";
import gbtb1 from "../images/gbtb_1.jpg";
import stadium1 from "../images/stadium_1.jpg";
import stadium2 from "../images/stadium_2.jpg";
import stadium3 from "../images/stadium_3.jpg";
import stadium4 from "../images/stadium_4.jpg";
import stadium5 from "../images/stadium_5.jpg";
import rafflesmarina1 from "../images/rafflesmarina_1.jpg";
import rafflesmarina2 from "../images/rafflesmarina_2.jpg";
import rafflesmarina3 from "../images/rafflesmarina_3.jpg";
import rafflesmarina4 from "../images/rafflesmarina_4.jpg";
import marineparade1 from "../images/marineparade_1.jpg";

const images = [
  {
    image: mbs1,
  },
  {
    image: mbs2,
  },
  {
    image: mbs3,
  },
  {
    image: mbs4,
  },
  {
    image: mbs5,
  },
  {
    image: christmas1,
  },
  {
    image: christmas2,
  },
  {
    image: christmas3,
  },
  {
    image: christmas4,
  },
  {
    image: yk1,
  },
  {
    image: yk2,
  },
  {
    image: funan1,
  },
  {
    image: funan2,
  },
  {
    image: funan3,
  },
  {
    image: funan4,
  },
  {
    image: raffles1,
  },
  {
    image: drive1,
  },
  {
    image: drive2,
  },
  {
    image: cny1,
  },
  {
    image: cny2,
  },
  {
    image: cny3,
  },
  {
    image: cny4,
  },
  {
    image: sunset1,
  },
  {
    image: dragon1,
  },
  {
    image: dragon2,
  },
  {
    image: dragon3,
  },
  {
    image: chinatown1,
  },
  {
    image: gbtb1,
  },
  {
    image: stadium1,
  },
  {
    image: stadium2,
  },
  {
    image: stadium3,
  },
  {
    image: stadium4,
  },
  {
    image: stadium5,
  },
  {
    image: rafflesmarina1,
  },
  {
    image: rafflesmarina2,
  },
  {
    image: rafflesmarina3,
  },
  {
    image: rafflesmarina4,
  },
  {
    image: marineparade1,
  },
];

export default images;